import type { ConnectionStatus } from '../hooks/use-simulador-client';

const STATUS_LABELS: Record<ConnectionStatus, string> = {
  idle: 'Iniciando',
  'requesting-token': 'Autenticando',
  connecting: 'Conectando',
  connected: 'Conectado',
  error: 'Erro',
};

const STATUS_COLORS: Record<ConnectionStatus, string> = {
  idle: '#9ca3af',
  'requesting-token': '#f59e0b',
  connecting: '#f59e0b',
  connected: '#10b981',
  error: '#ef4444',
};

export function Header({
  status,
  tenantId,
  conversationId,
}: {
  status: ConnectionStatus;
  tenantId: string;
  conversationId: string | null;
}): JSX.Element {
  return (
    <header
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        background: 'var(--lume-panel)',
        borderBottom: '1px solid var(--lume-border)',
        gap: '16px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            background: 'var(--lume-accent-soft)',
            color: 'var(--lume-accent)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: '14px',
          }}
        >
          L
        </div>
        <div>
          <div style={{ fontWeight: 600, fontSize: '14px' }}>Atendimento Lume</div>
          <div style={{ fontSize: '11px', color: 'var(--lume-muted)' }}>
            {conversationId !== null && conversationId.length > 0
              ? `Conversa ${conversationId.slice(0, 12)}…`
              : 'Aguardando primeira mensagem'}
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '12px',
          color: 'var(--lume-muted)',
        }}
        title={`tenant=${tenantId}`}
      >
        <span
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: STATUS_COLORS[status],
          }}
        />
        {STATUS_LABELS[status]}
      </div>
    </header>
  );
}
